module.exports = __webpack_public_path__ + "static/media/home.2536ac09.svg";